/**
 * API endpoint paths, relative to environment.apiUrl.
 * Used with ApiService (e.g. apiService.post(ApiConstants.AUTH.LOGIN, body)).
 */
export const ApiConstants = {
  COUNTRIES: 'countries',
  AUTH: {
    LOGIN: 'auth/login',
    LOGOUT: 'auth/logout',
    REGISTER: 'auth/register',
    SEND_OTP: 'auth/send-otp',
    VERIFY_OTP: 'auth/verify-otp',
    ME: 'auth/me',
    FORGOT_PASSWORD_SEND_OTP: 'auth/forgot-password/send-otp',
    FORGOT_PASSWORD_RESET: 'auth/forgot-password/reset'
  }
} as const;
